import React, { useEffect } from 'react';

import { TitleScoringProps } from './index';

/** Access code lives on the match game; submitting with this payload triggers a scores pull. */
const QuizWhizzerScoring = ({ setAutoScoringData }: TitleScoringProps): JSX.Element => {
    useEffect(() => {
        setAutoScoringData(JSON.stringify({ pull: true }));
        return () => setAutoScoringData(undefined);
    }, [setAutoScoringData]);

    return (
        <p className="mb2x">
            Import standings from the access code already saved on this match game. Scores use race{' '}
            <code>position</code> converted to LeagueSpot points (higher is better).
        </p>
    );
};

export default QuizWhizzerScoring;
